import { render, staticRenderFns } from "./AdjustDesign.vue?vue&type=template&id=f8958ab6&scoped=true"
import script from "./AdjustDesign.vue?vue&type=script&lang=js"
export * from "./AdjustDesign.vue?vue&type=script&lang=js"
import style0 from "./AdjustDesign.vue?vue&type=style&index=0&id=f8958ab6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8958ab6",
  null
  
)

export default component.exports